export const GENERO = [
  "MASCULINO",
  "FEMININO",
  "NÃO_INFORMAR",
  "OUTRO",
] as const;
export type GENERO_TYPE = (typeof GENERO)[number];
